import { AI_EVENTS } from 'modules/ai/constants/aiAnalyticsEvents';
import trackEvent from 'utils/trackEvent';

import { buildAiTrackingProps } from './buildAiTrackingProps';

type MixpanelClient = {
  config?: { token?: string };
  track: (eventName: string, properties: Record<string, unknown>) => void;
};

type TrackAiActivityParams = {
  mixpanel: MixpanelClient | null | undefined;
  state: Parameters<typeof buildAiTrackingProps>[0];
  eventName: (typeof AI_EVENTS)[keyof typeof AI_EVENTS];
  extras?: Parameters<typeof buildAiTrackingProps>[1];
};

export const trackAiActivity = ({
  mixpanel,
  state,
  eventName,
  extras = {},
}: TrackAiActivityParams): void => {
  if (!mixpanel?.config?.token) return;

  trackEvent(mixpanel, eventName, buildAiTrackingProps(state, extras));
};

export default trackAiActivity;
